// src/services/AboutAndSustainabilityContentService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  GET_ABOUT_US_SUSTAINABILITY_CONTENT,
  HOME_PAGE_UPDATE,
  UPDATE_ABOUT_US_SUSTAINABILITY_CONTENT,
} from "../../config/constants"; // Adjust endpoints as per your config

const AboutAndSustainabilityContentService = createApi({
  reducerPath: "AboutAndSustainabilityContentService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["AboutAndSustainabilityContent"],
  endpoints: (builder) => ({
    getAboutAndSustainabilityContentDetails: builder.query({
      query: (bodyData) => ({
        url: GET_ABOUT_US_SUSTAINABILITY_CONTENT, // Endpoint to fetch settings list
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["AboutAndSustainabilityContent"],
    }),
    updateAboutAndSustainabilityContent: builder.mutation({
      query: ({ updatedData }) => ({
        url: `${UPDATE_ABOUT_US_SUSTAINABILITY_CONTENT}`, // Endpoint to update a settings
        method: "PUT",
        data: updatedData, // Updated settings data
      }),
      invalidatesTags: ["AboutAndSustainabilityContent"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetAboutAndSustainabilityContentDetailsQuery,
  useUpdateAboutAndSustainabilityContentMutation,
} = AboutAndSustainabilityContentService;

// Export the reducer to be included in the store
export default AboutAndSustainabilityContentService;
